// this method returns group of the admin user
// so we can get analyses of the group that admin belongs to
export const getAdminGroup = (roles: string[] | undefined): string | undefined => {
  if (roles === undefined) return undefined;

  const adminPostfix = '_admin';
  const _roles = roles.filter((r) => r.includes(adminPostfix));
  return _roles[0] ? _roles[0].replace(adminPostfix, '') : undefined;
};
